export { default as hands } from './hands.rules'
export { default as bombOutOfBounds } from './bomb-out-of-bounds.rules'
export { default as bombCatch } from './bomb-catch.rules'
export { default as levelProgress } from './level-progress.rules'
export { default as spritesMoves } from './sprite-moves.rules'
export { default as spritesCreation } from './sprite-spawns.rules'
export { default as spritesRemoval } from './sprite-removal.rules'
export { default as effects } from './shake.rules'


// WEBPACK FOOTER //
// ./src/game/bomber/rules/index.ts